
import {Component, OnInit, Input} from 'ng-metadata/core';
import {JwtUtilService} from "../../../../security/jwtUtil.service";

import {
    BestOffer,
    mmsIdOfferOutputMap,
    moreOptionsUIrow,
    morePolicies,
    OfferOutputResults
} from "../BestOffer.interface";
import {PhysicalBestOfferService} from "../physicalBestOffer/physicalBestOffer.service";


@Component({
    "inputs":['showmoredeliveryoptions','bestoffer','openphysicalform'],
    "selector": 'prm-physical-delivery-options-table',
    templateUrl: 'components/search/fullView/ngrs/physicalDeliveryOptionsTable/physicalDeliveryOptionsTable.html',
})

export class PrmPhysicalDeliveryOptionsTable{
    @Input() mmsid:string;
    private _results:moreOptionsUIrow[] = new Array(0);
    private _policies:morePolicies[] = new Array(0);
    private _isCollapsed: boolean;

    constructor (private physicalBestOfferService: PhysicalBestOfferService, private jwtUtilService: JwtUtilService) {
        let results: mmsIdOfferOutputMap[] = physicalBestOfferService.getResultsObject();
        let userId=this.jwtUtilService.getDecodedToken().userGroup;
        let hash=userId+'_'+this.mmsid;
        this._policies = results[hash].moreResultsPolicies;
    }
    ngOnInit(){

        this._isCollapsed=false;
    }  
    
    public getResults(){

        return this._results;
    }

    public getPolicies(){
        return this._policies;
    }

    public collapse(){
        this._isCollapsed=!this._isCollapsed;
    }

    public isCollapse(){
        return this._isCollapsed;
    }

    public close(){
        this.showmoredeliveryoptions.showMoreDeliveryOptions=false;
    }


}


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/fullView/ngrs/physicalDeliveryOptionsTable/physicalDeliveryOptionsTable.directive.ts